import axiosapi from "./axiosAPI";

// Get All BroadCategories
export const getAllBroadCategories = async (
    setBroadCategories,
    setFetcherror,
   
) => {

    
	try{
		const res =await axiosapi.get("/broadcategories");
        setBroadCategories(res.data.data ? res.data.data : {});

	}
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Fetch BroadCategories");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Fetch BroadCategories");
		}
		
	}
	
};



// Get One BroadCategory
export const getOneBroadCategory = async (
    pkid,
    setFetcherror,  
    setBroadCategory
    
)=>{
	try{
		const res =await axiosapi.get(`/broadcategories/${pkid}`);
        setBroadCategory(res.data.body);
       
	}
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Fetch BroadCategory");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Fetch BroadCategory");
		}
		
	}
	
};


// Create New BroadCategory
export const createBroadCategory = async (
    
    broadCategory,
    setBroadCategory,
    setFetcherror,
    handleAllToasts,
    setBroadCategories

) => {

   

    if (!broadCategory ) {
        handleAllToasts(2, "No BroadCategory Provided"); 
            return; 
        }

    const PushItem = {
            name: broadCategory,
        };

    try{
        await axiosapi.post("/broadcategories/",PushItem );
        setBroadCategory("");
        getAllBroadCategories(setBroadCategories, setFetcherror);
        handleAllToasts(1, "BroadCategory Created Successfully");
    }
    catch(err){
        if(err.response){
            //Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Could Not Create New BroadCategory");
            handleAllToasts(2, "Could Not update The BroadCategory");
            
            
        }else{
            //No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Could Not Create New BroadCategory");
            handleAllToasts(2, "Could Not update The BroadCategory");
            
        }
        
    }
    
}


// Edit Existing BroadCategory

export const editBroadCategory = async (
    broadCategorypkid,
    broadCategory,
    setBroadCategory,
    setFetcherror,
    handleAllToasts,
    setBroadCategories
              
        ) => {
           

            if (!broadCategory) {
                handleAllToasts(2, "No BroadCategory Name Provided"); 
                    return;  
                }

            const PushItem = {

                    id:broadCategorypkid,
                    name: broadCategory,
                };

            try{
                await axiosapi.patch("/broadcategories/",PushItem );
                setBroadCategory("");
                getAllBroadCategories(setBroadCategories, setFetcherror);
                handleAllToasts(1, "BroadCategory Updated Successfully");
            }
            catch(err){
                if(err.response){
                    //Error Obtained from Backend not in 200
                    console.log(err.response.data);
                    console.log(err.response.status);
                    console.log(err.response.headers);
                    setFetcherror("Could Not Update BroadCategory");
                    handleAllToasts(2, "Could Not Update BroadCategory");
                    
                    
                }else{
                    //No response Obtained from the server.
                    console.log(`Error: ${err.message}`);
                    setFetcherror("Could Not Update BroadCategory");
                    handleAllToasts(2, "Could Not Update BroadCategory");
                    
                }
                
            }
            
};



// Delete Existing BroadCategory.

export const deleteBroadCategory = async (
    broadCategorypkid,
    setcountries,
    setFetcherror,
    handleAllToasts
)=>{
    try {
        const res = await axiosapi.delete(`/broadcategories/${broadCategorypkid}`);
        let finalData = res.data.message;
        getAllBroadCategories(setcountries, setFetcherror);
        handleAllToasts(1, "BroadCategory Deleted Successfully");
        console.log("Deleted:", finalData);
    }
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
			console.log(err.response.data);
			console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Delete BroadCategory");
            handleAllToasts(2,"Error: Could Not Delete BroadCategory");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Delete BroadCategory");
            handleAllToasts(2,"Error: Could Not Delete BroadCategory");
		}
		
	}
	
};